import { GET, POST } from "config/api.config";
import { ABOUT_US, HOMEPAGE } from "config/apiEndPoint";
import { array } from 'prop-types';
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { toast } from 'react-toastify';

export const fetchHomePageDetails = async (data = array()) => {
    try {
        let url = `${HOMEPAGE.FETCH_HOME_PAGE}`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(error);
        // console.log(error);
    }
};

export const UpdateHomePageDetails = async (data = array()) => {
    try {
        let url = `${HOMEPAGE.UPDATE_HOME_PAGE}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
        // console.log(error);
    }
};

export const getSubscriptionList = async (data = array()) => {
    try {
        let url = data._SubscriptionId ? `${HOMEPAGE.SUBSCRIPTION_LIST}/${data._SubscriptionId}` : `${HOMEPAGE.SUBSCRIPTION_LIST}`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(response.message);
    }
};

export const getPrivacyPolicy = async (data = array()) => {
    try {
        let url = `${HOMEPAGE.PRIVACY_POLICY}`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(error);
        // console.log(error);
    }
};

export const updatePrivacyPolicy = async (data = array()) => {
    try {
        // in api end point page there have a contact us object where mentioned the end point of api
        const url = `${HOMEPAGE.UPDATE_PRIVACY_POLICY}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
    }
};

export const fetchIpAddressAndRegion = async (data = array()) => {
    try {
        let url = `${HOMEPAGE.FETCH_IPADDRESS_AND_REGION}`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(error);
        // console.log(error);
    }
};

export const fetchHomeHealthStatus = async (data = array()) => {
    try {
        let url = `${HOMEPAGE.HOME_HEALTH_STATUS}`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(error);
        // console.log(error);
    }
};